export default __webpack_public_path__ + "static/media/M3_02.ab580462.jpg";